import {  useQuery } from "react-query";
import clientApi from "./client";
import { Signer } from "utils/signpin";
import {
  wallet,
  walletDeposit,
  walletQuote,
  walletSwap,
  walletWithdraw,
} from "./routes";
import { Storage } from "utils/clientStorage";

// ---------- WALLET BALANCE -----------

const fetchWalletBalance = async () => {
  try{
    const { data } = await clientApi.get(wallet);
    return data;
  }
  catch(err){
    throw new Error(err);
  }
  
};

export const useGetWalletBalance = () => {
  return useQuery("wallet-balance", fetchWalletBalance);
};

// ---------- WALLET DEPOSIT -----------

export const handleWalletDeposit = async (currency, amount) => {
  const { data } = await clientApi.get(walletDeposit(currency, amount));
  return data;
};



// ---------- WITHDRAW FROM WALLET -----------

export const withdrawFromWallet = async (currency, amount, accountId,pin) => {
  const token = window !== undefined ? Storage.getItem("TOKEN") || "" :""
      var api = walletWithdraw(currency, amount, accountId);
      var nonce = Signer.nonce();
      var signature = await Signer.digest(pin, nonce, api);
      console.log(signature)
  const { data } = await clientApi.get(
    api,
    {
      headers: {
        				'Nonce': nonce,
        				'Signature': signature,
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`, // Input token
                "Access-Control-Allow-Origin": "*"
        			}
    }
  );
  return data;
};



// ---------- WALLET QUOTE -----------

export const handleWithdrawQuote = async (
  fromcurrency,
  fromamount,
  tocurrency,
  toamount
) => {
  const { data } = await clientApi.get(
    walletQuote(fromcurrency, fromamount, tocurrency, toamount)
  );
  return data;
};



// ---------- WALLET SWAP -----------

export const handleWithdrawSwap = async (
  fromcurrency,
  fromamount,
  tocurrency,
  toamount
) => {
  const { data } = await clientApi.get(
    walletSwap(fromcurrency, fromamount, tocurrency, toamount)
  );
  return data;
};


